export const REPORTING_LABELS = {
  // Aggregated call CSV headers
  AI_TALK_TIME: 'AI Talk Time',
  AVG_AI_TALK_TIME: 'Avg AI Talk Time',
  ESTIMATED_TIME_SAVED: 'Estimated time saved',
  INBOUND_CALLS: 'Inbound Calls',
  OUTBOUND_CALLS: 'Outbound Calls',
  INBOUND_COLUMN: 'Inbound',
  OUTBOUND_COLUMN: 'Outbound',
  CALLS: 'Calls',
  CALLS_TRANSFERRED: 'Calls Transferred',
  NEEDS_HUMAN_HELP: 'Needs Human Help',
  NOT_RESOLVED_PCT: 'Not Resolved Percentage',
  TOTAL_PROCESSED_CALLS: 'Total Processed Calls',

  // Individual call CSV headers
  DATE: 'Date',
  DIRECTION: 'Direction',
  FROM: 'From',
  TO: 'To',
  AI_TALK_TIME_S: 'AI Talk Time (s)',
  RESOLVED: 'Resolved',
  HANGUP: 'Hangup',
  SENTIMENT: 'Sentiment',
  HANDOFF_RULE: 'Handoff Rule',
  TRANSCRIPT: 'Transcript',

  // SMS headers
  TOTAL_MESSAGES_HANDLED: 'Total Messages Handled',
  TOTAL_PROCESSED_MESSAGES: 'Total Processed Messages',
  SMS_NEEDS_HUMAN_HELP: 'Needs Human Help',
  SMS_NOT_RESOLVED_PCT: 'Not Resolved Percentage',
} as const
